!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('backboneMdl',[
      'lodash',
      'backbone',
      'app/config/constants'
    ], factory)
  }
}(
  /**
   * @param _
   * @param Backbone
   * @param CONSTANTS
   * @returns {{Model: BackboneBaseModel, Collection: BackboneBaseCollection}}
   */
  function (
    _,
    Backbone,
    CONSTANTS
  ) {
    /**
     * Backbone Model Wrapper Class
     */

    var LOG_LABEL = 'BCKBN BASE'

    var STATUS = CONSTANTS.STATUS

    var /**
       * @typedef {Backbone.Model} BackboneBaseModel
       */
      /**
       * @type BackboneBaseModel
       */
      BaseModel = Backbone.Model.extend(
        /** @lends BaseModel.prototype */ {
          isSurveyEngineMdl: true, // no purpose - just telling.
          toString: function(){
            var _this = this
            return 'mdl-' + _this.id
          },
          /**
           * @constructs
           */
          initialize: function () {
            var _this = this;

            _this.initStatus();

            _this.set("cid", _this.cid);

            if (_this.init) {
              _this.init.apply(_this, arguments);
            }
          },

          reset: function(){
            var _this = this
            _this.set(_this.defaults())
          },
          clone: function (options) {
            // overwrite clone to be a deep clone of the attributes!
            var _this = this

            var _options = _.merge({
                __clones: {origs: [], clones: []}
              }, (options || {})),
              thisModel = _this.constructor,
              clonedAttributes = {};

            _options.__clones = (options || {}).__clones || _options.__clones

            _.forEach(_this.attributes, function (val, attr) {
              switch (typeof val) {
                case "object":
                  if(val === null){
                    break;
                  }

                  var
                    origVal = val,
                    // find clone in clone stack to avoid endless cloning
                    isClone = _options.__clones.clones.indexOf(origVal) !== -1,
                    // use existing clone if possible
                    cloneIdx = !isClone && _options.__clones.origs.indexOf(origVal),
                    clone = _options.__clones.clones[cloneIdx]

                  if(isClone){
                    break; // make no changes, keep the clone
                  }

                  if(clone){
                    val = clone
                  }else if(typeof val.clone === 'function'){
                    val = val.clone(_options)
                  }else{
                    val = _.clone(val, true)
                    // try {
                    //   val = JSON.parse(JSON.stringify(val));
                    // } catch (err) {
                    //   console.error(
                    //     "error on cloning object via JSON",
                    //     _this.attributes
                    //   );
                    // }
                  }

                  if(!clone){
                    clone = val
                    _options.__clones.origs.push(origVal)
                    _options.__clones.clones.push(clone)
                  }
                  break;
                default:
                  // no change
                  break;
              }

              clonedAttributes[attr] = val;
            });

            return new thisModel(clonedAttributes);
          },

          /**
           * creates a JSON only from the attributes that are differend to the default settings
           * @returns {{}}
           */
          toDiffJSON: function () {
            var _this = this;

            var _thisDiffJson = {},
              //_thisDefaults = typeof(_this.__proto__.defaults) == "function" ? _this.__proto__.defaults() : _this.__proto__.defaults,
              _thisDefaults =
                typeof _this.defaults == "function"
                  ? _this.defaults()
                  : _this.defaults;

            _.forEach(_this.attributes, function (val, key) {
              if (val && val.toDiffJSON) {
                val = val.toDiffJSON();
              } else if (val && val.toJSON) {
                val = val.toJSON();
              }

              var tmpDefaultVal = _thisDefaults[key];
              if (tmpDefaultVal && tmpDefaultVal.toDiffJSON) {
                tmpDefaultVal = tmpDefaultVal.toDiffJSON();
              } else if (tmpDefaultVal && tmpDefaultVal.toJSON) {
                tmpDefaultVal = tmpDefaultVal.toJSON();
              }

              if (
                tmpDefaultVal != undefined &&
                !_.isEqual(tmpDefaultVal, val)
              ) {
                _thisDiffJson[key] = val;
              }
            });

            return _thisDiffJson;
          },

          // status

          status: null,
          initStatus: function () {
            var _this = this;
            /*
             TEMPORARY:  "10-temporary",

             LOADING:    "20-loading",
             LOADED:     "21-loaded",

             READY:      "22-ready",
             RESET:      "23-reset",

             RUNNING:    "25-running",
             PAUSED:     "26-paused",
             STOPPED:    "27-stopped",

             CHANGED:    "30-changed",
             SAVING:     "31-saving",
             SAVED:      "32-saved",

             DELETED:    "50-deleted",
             DESTROYED:  "51-destroyed",
             FAILED:     "52-failed"
             */

            var defaultStatus = STATUS.TEMPORARY;

            if (_this.defaults && _this.defaults.status) {
              defaultStatus = _this.defaults.status;

              if (
                !_.findKey(STATUS, function (stat) {
                  return stat == defaultStatus;
                })
              ) {
                console.log(
                  LOG_LABEL,
                  "unexpected default status; status handling not set for this model",
                  _this,
                  defaultStatus
                );
                return;
              }
            }

            _this.setStatus(defaultStatus); // default.

            _this.on("isTemporary", function () {
              _this.setStatus(STATUS.TEMPORARY);
            });

            _this.on("isLoading", function () {
              if (_this.status < STATUS.LOADING) {
                _this.setStatus(STATUS.LOADING);
              }
            });
            _this.on("hasLoaded", function () {
              if (_this.status < STATUS.LOADED) {
                _this.setStatus(STATUS.LOADED);
              }
            });
            _this.on("isReady", function () {
              if (_this.status < STATUS.READY) {
                _this.setStatus(STATUS.READY);
              }
            });
            _this.on("hasChanged", function () {
              _this.setStatus(STATUS.CHANGED);
            });
            _this.on("isSaving", function () {
              _this.setStatus(STATUS.SAVING);
            });
            _this.on("hasSaved", function () {
              if (_this.status != STATUS.CHANGED) {
                _this.setStatus(STATUS.SAVED);
              }
            });
            _this.on("isDeleted", function () {
              if (_this.status < STATUS.DELETED) {
                _this.setStatus(STATUS.DELETED);
              }
            });
            _this.on("isDestroyed", function () {
              if (_this.status < STATUS.DESTROYED) {
                _this.setStatus(STATUS.DESTROYED);
              }
            });
            _this.on("hasFailed", function () {
              if (_this.status < STATUS.FAILED) {
                _this.setStatus(STATUS.FAILED);
              }
            });
          },
          setStatus: function (newStatus) {
            var _this = this;

            if (
              !newStatus ||
              !_.find(STATUS, function (status) {
                return status == newStatus;
              })
            ) {
              console.error(
                LOG_LABEL,
                "status missing / wrong status",
                newStatus,
                STATUS
              );
              return;
            }

            //if(newStatus == _this.status)
            //    return;

            var oldStatus = _this.status;
            _this.status = newStatus;
            _this.set("status", newStatus, { silent: true });

            _this.trigger("status:" + newStatus, _this, newStatus, oldStatus);
            _this.trigger("status", _this, newStatus, oldStatus);

            if (_this.collection) {
              _this.collection.trigger("status", _this, newStatus, oldStatus);
            }
          },
          /**
           * @deprecated use attribute this.status instead
           */
          getStatus: function () {},

          /**
           * returns the true current position of an element in the collection
           * ignoring deleted elements
           * @return {number|null}
           */
          getPosition: function () {
            var _this = this;
            if (!_this.collection) return null;

            return _this.collection.getElementsOrder().indexOf(_this.cid);
          },

          /**
           * clone set - clones values obj before returning it
           * @param key
           * @param val
           * @param options
           * @return {*}
           */
          cset: function (key, val, options) {
            var _this = this;

            if (typeof key == "string") {
              val = _.cloneDeep(val);

              return _this.set(key, val, options);
            } else {
              options = val;
              var attrs = key,
                res;

              _.each(attrs, function (val, key) {
                res = _this.cset(key, val, options);
              });

              return res;
            }
          },
          cget: function (attr) {
            var _this = this;
            /**
             * clone get
             * clones result obj before returning it
             */

            return _.cloneDeep(_this.get(attr));
          },
          pget: function (path) {
            var
              _this = this,
              _path = path && path
                // replace e.g. a[0].x.y -> a.0.x.y
                .replace(/\[(\d+)]/g, '.$1')
                .split("."),
              isModel = function(obj){
                return obj instanceof Backbone.Model
              },
              isColl = function(obj){
                return obj instanceof Backbone.Collection
              },
              testPath,
              tmpVal = undefined

            // console.log(LOG_LABEL, 'PGET', _path)

            if (!_path || !_path.length) {
              return _this.attributes
            }

            try{
              testPath = _path.shift()
              tmpVal = _this.get(testPath)

              while(_path.length){
                testPath = _path.shift()
                // console.log(LOG_LABEL, 'PGET', 'step', testPath, tmpVal, isModel(tmpVal), isColl(tmpVal))

                if(isColl(tmpVal)){
                  tmpVal = tmpVal.at(testPath)
                }else if(isModel(tmpVal)){
                  tmpVal = tmpVal.get(testPath)
                }else{
                  tmpVal = tmpVal && tmpVal[testPath]
                }
              }

              // console.log(LOG_LABEL, 'PGET', 'res', testPath, tmpVal, isModel(tmpVal), isColl(tmpVal))
              return tmpVal
            }catch(err){
              console.debug(LOG_LABEL, 'PGET', 'failed', {path: path}, err)
            }
            // console.log(LOG_LABEL, 'PGET', 'path not found', path, _this.toJSON())
          },
          pset: function(path, val, options){
            var _this = this,
              _path = path
                // replace e.g. a[0].x.y -> a.0.x.y
                .replace(/\[(\d+)]/g, '.$1')
                .split('.'),
              isModel = function(obj){
                return obj instanceof Backbone.Model
              },
              isColl = function(obj){
                return obj instanceof Backbone.Collection
              }

            // check if path contains a sub model
            var path1 = _.clone(_path),
              testPath = [],
              testVal = undefined

            while(path1.length){
              // console.log(
              //     LOG_LABEL,
              //     'PSET',
              //     'testpath',
              //     { testPath, path1, testVal },
              //     isModel(testVal),
              //     isColl(testVal)
              // )
              if(isModel(testVal)){
                return testVal.pset(path1.join('.'), val, options)

              }else if(isColl(testVal)){
                var idx = +path1.shift()
                testVal = testVal.at(idx)
              }else{
                testPath = testPath.concat(path1.shift())
                testVal = _this.pget(testPath.join('.'))
              }
            }

            var
              attrPath = _path.shift(),
              attrVal = _this.cget(attrPath),
              setPath = _path.join('.')
                // replace a.0.x.y -> a[0].x.y
                .replace(/\.(\d+)/g, '[$1]')

            if(_path.length === 0){
              return _this.set(attrPath, val, options)
            }

            // console.log(LOG_LABEL, 'PSET', {path, val, options}, {attrPath, attrVal, setPath})

            _.set(attrVal, setPath, val)
            return _this.set(attrPath, attrVal, options)
          },
          /**
           * merging a value into a path
           * !! this is not working properly if to be merged values contain Models or Coll
           * @param {string|any} pathOrVal
           * @param {any|object} [valOrOptions]
           * @param {object} [options]
           * @returns {*}
           */
          merge: function (pathOrVal, valOrOptions, options) {
            var
              isModelOrColl = function(obj){
                return obj instanceof Backbone.Model || obj instanceof Backbone.Collection
              }

            var
              _this = this,
              _path = typeof pathOrVal === 'string' ? pathOrVal
                // replace e.g. a[0].x.y -> a.0.x.y
                .replace(/\[(\d+)]/g, '.$1') : null,
              _val = _path === null ? pathOrVal : valOrOptions,
              _options = _path === null ? valOrOptions : options,
              curVal, newVal

            if(_val === null || typeof _val !== 'object'){
              _this.pset(_path, _val, options)
              return
            }

            if(_path){
              curVal = _this.pget(_path)
            }else{
              curVal = _this.toJSON()
            }

            var
              mergeFn = function(a, b){
                if(Array.isArray(b)){
                  return b
                }else if(typeof a !== typeof b){
                  return b
                }else if(b === null || typeof b !== 'object'){
                  return b
                }else if(a === null || typeof a !== 'object') {
                  return b
                }else if(_.isEqual(a, b)){
                  return a
                }else if(isModelOrColl(b)){
                  console.warn(LOG_LABEL, 'merge', 'to be merged value is model / col! no merging done but directly assigned')
                  return b
                }

                // is object
                _.forEach(b, function(valB, key){
                  var valA = a[key]
                  a[key] = mergeFn(valA, valB)
                })

                return a
              }

            newVal = mergeFn(curVal, _val)

            if(_path){
              _this.pset(_path, newVal, _options)
            }else{
              _this.set(newVal, _options)
            }
          },
          /**
           * returns a clone of the models data structure
           * @param {Object} options
           * @param {boolean} [options.ignorePrivateKeys=true] ignore ^__* keys
           * @param {number} [options.maxLoop=1] max times to loop over an object
           * @returns {object}
           */
          toJSON: function(options) {
            var
              _this = this,
              _options = _.merge({
                ignorePrivateKeys: true, // ignore keys starting with '__'
                filterKeys: [], // array of "to be filtered out attribute names",
                maxLoop: 4,
                maxDepth: 12,
                simple: false,
                __depth: 0,
                __antiloopstack: {stack: [], levelCnt: {}}
              }, options || {}),
              json = {}

            _options.__antiloopstack = (options || {}).__antiloopstack ||  {stack: [], levelCnt: {}}

            if(_options.simple){
              return _.clone(_this.attributes)
            }

            json = customClone(_this.attributes, _options)

            return json
          }
        }
      );

    var mdlObj = {};
    {
        // -----------  TRACKING

        /**
         * @param {{value: object}} state
         * @param mdl
         * @private
         */
        function _track(state, mdl) {
            state.value = _.merge(state.value, _.clone(mdl.changed, true))
        }

        /**
         * logs all changes to the model and its sub-models to an object
         * @template {object} T
         * @param {T} [toObj]
         * @param {string} [key]
         * @returns {{stop: stop, changes: T | {}}} returns a simple stop() method to stop the tracking
         */
        mdlObj._trackingQueue = []
        mdlObj.track = function () {
            var _this = this,
                _toObj = {},
                _state = { value: _toObj }

            var isAlreadyTracking = !!_this._trackingQueue.filter(function (itm) {
                return itm.obj === _toObj
            }).length

            if (isAlreadyTracking) {
                // untrack first
                _this.untrack(_toObj)
            }

            var trackingFn = _track.bind(_this, _state),
                trackingLog = { obj: _toObj, fn: trackingFn }

            _this._trackingQueue.push(trackingLog)
            _this.on('change', trackingFn)

            var subtracks = {}
            Object.keys(_this.attributes).map(function (attr) {
                var attrVal = _this.attributes[attr]
                if (attrVal && attrVal.track) {
                    subtracks[attr] = attrVal.track()
                }
            })

            return {
                _trackObject: true,
                changes: function () {
                    var changes = _.clone(_state.value, true)
                    Object.keys(subtracks).map(function (attr) {
                        changes[attr] = subtracks[attr].changes()
                    })
                    return changes
                },
                stop: function () {
                    _this.untrack(_toObj)
                },
            }
        }
        /**
         * stop tracking to this object
         * @param {object} [toObj] if omitted this stops all current tracking
         */
        mdlObj.untrack = function (toObj) {
            var _this = this
            if (!toObj) {
                // untrack all current running tracks
                _this._trackingQueue.map(function (itm) {
                    _this.untrack(itm.obj)
                })
                return
            }

            var trackingIdx = _.findIndex(_this._trackingQueue, function (itm) {
                    return itm.obj === toObj
                }),
                trackingItms = _this._trackingQueue.splice(trackingIdx, 1),
                trackingLog = trackingItms[0]

            if (!trackingLog) return

            _this.off('change', trackingLog.fn)
            Object.keys(_this.attributes).map(function (attr) {
                var attrVal = attr
                if (attrVal && attrVal.untrack) {
                    attrVal.untrack(toObj[attr])
                }
            })
        }
        /**
         * use tracked changes and "merge" them into a model and its submodels
         * @param {{_trackObject: true, changes: function, stop: function} | object} trackObj
         * @param {object} [options] event options e.g. silent=true
         */
        mdlObj.applyTrack = function (trackObj, options) {
            var _this = this,
                _options = _.merge(
                    {
                        silent: false,
                    },
                    options || {}
                ),
                isTrackObj = trackObj._trackObject,
                changeObj = isTrackObj ? trackObj.changes() : trackObj,
                changedAttributeNames = (changeObj && Object.keys(changeObj)) || [],
                setChanges = 0

            if (isTrackObj) {
                trackObj.stop()
            }

            if (!changedAttributeNames.length) {
                return
            }

            changedAttributeNames.map(function (attr) {
                var attrVal = _this.get(attr)
                if (attrVal && attrVal.applyTrack) {
                    if(attrVal.applyTrack(changeObj[attr], _options)){
                      setChanges++
                    }
                } else {
                    if(_this.get(attr) !== changeObj[attr]){
                      _this.set(attr, changeObj[attr], { silent: true })
                      setChanges++
                    }
                }
                _this.trigger('change:' + attr, _this)
            })

            if(setChanges === 0)
              return

            _this.changed = changeObj
            _this.trigger('change', _this, _options)
        }
    }


    BaseModel = BaseModel.extend(mdlObj);

    var /**
       * @typedef BackboneBaseCollection
       * @extends Backbone.Collection
       */
      /**
       * @type BackboneBaseCollection
       */
      BaseCollection = Backbone.Collection.extend(
        /** @lends BaseCollection.prototype */ {
          isSurveyEngineColl: true,
          comparator: "position",
          model: BaseModel,
          toString: function(){
            var _this = this
            return 'coll-' + _this.id
          },
          /**
           * @constructs
           */
          initialize: function () {
            var _this = this;

            _this.initStati();

            _this.on("sort", function (coll, options) {
              if (_this._hasNewOrder()) {
                _this.trigger("sorted", coll, options);
              }
            });

            if (_this.init) {
              _this.init.apply(_this, arguments);
            }
          },

          isValid: function () {
            var _this = this,
                validationErrors = _this.models
                    .map(function (mdl) {
                        return !mdl.isValid() && ('[' + mdl.toString() + '] ' + mdl.validationError)
                    })
                    .filter(function (validationError) {
                        return !!validationError
                    }),
                validationError =
                    (validationErrors.length &&
                      validationErrors.join('\n')) ||
                    null

            _this.validationError = validationError

            return !validationError
          },

          // stati
          initStati: function () {
            var _this = this;

            _this.on("status", function (mdl, status) {
              _this._updateStati();
            });
          },
          stati: {},
          _updateStati: function () {
            var _this = this;
            var active = 0,
              newStati = _.countBy(_this.models, function (mdl) {
                if (mdl.status >= STATUS.LOADED && mdl.status <= STATUS.DELETED)
                  active++;
                return mdl.status;
              });

            newStati.active = active;
            _this.stati = newStati;

            newStati.total = _this.length;

            _this.trigger("stati", _this, newStati);
          },

          // internal
          _order: "",
          _hasNewOrder: function () {
            var _this = this;

            var curOrder = _this.pluck("cid").join(":");
            if (curOrder == _this._order) return false;

            _this._order = curOrder;
            return true;
          },

          _updateIdReference: function (oldId, newId, options) {
            var _this = this;

            var _options = _.merge(
              {
                keepOldReference: true,
              },
              options || {}
            );

            if (_this._byId[oldId]) {
              _this._byId[newId] = _this._byId[oldId];
            }

            if (!_options.keepOldReference) {
              delete _this._byId[oldId];
            }
          },

          // actions
          clone: function (options) {
            // overwrite clone to be a deep clone of the attributes!
            var _this = this
            
            var
              _options = _.merge({
                __clones: {origs: [], clones: []}
              }, (options || {}))
            _options.__clones = (options || {}).__clones || _options.__clones
            
            var
              origVal = _this,
              // find clone in clone stack to avoid endless cloning
              isClone = _options.__clones.clones.indexOf(origVal) !== -1,
              // use existing clone if possible
              cloneIdx = !isClone && _options.__clones.origs.indexOf(origVal),
              clone = _options.__clones.clones[cloneIdx]

            
            if(isClone) {
                return _this
            }

            var            
              thisClone = clone || new _this.constructor()

            if(!clone){
              clone = thisClone
              _options.__clones.origs.push(origVal)
              _options.__clones.clones.push(clone)
            }

            _this.models.map(function(mdl){
              thisClone.add(mdl.clone(options))
            })

            return thisClone;
          },

          getNotDeletedElements: function () {
            var _this = this;
            return _this.filter(function (mdl0) {
              return !mdl0.isDeleted;
            });
            //return _.filter(_this.toArray(), function(model){ return !model.isDeleted;})
          },

          getNotDeletedElementsCount: function () {
            var _this = this,
              elms = _this.getNotDeletedElements();

            return elms.length;
          },

          getElementsOrder: function () {
            var _this = this;

            return _.map(_this.getNotDeletedElements(), function (model) {
              return model.cid;
            });
          },

          fetchAll: function (options) {
            var _this = this;

            var _options = _.merge(
              {
                delayed: 0,
                max: -1,
              },
              options || {}
            );

            var fetchDelay = _options.delayed || 0,
              fetchInterval = 1,
              maxPages = _options.max ? _options.max : -1;

            _this.each(function (child) {
              if (!_options.forced && child.status >= STATUS.LOADING) {
                return;
              }

              if (maxPages === 0) return;
              maxPages--;

              setTimeout(function () {
                child.fetch(_options);
              }, fetchDelay * fetchInterval);

              fetchInterval++;
            });
          },
          /**
           * causes all child models to call a save()
           * @param {Object} [options] - forwared to childMdl.save(options)
           */
          saveAll: function (options) {
            var _this = this;
            _this.each(function (child) {
              child.save(options);
            });
          },

          moveChildAfter: function (childCid, afterChildCid, options) {
            var curPos = this.get(childCid).getPosition(),
              afterChildMdl = afterChildCid && this.get(afterChildCid),
              newPos = afterChildMdl
                ? // set position AFTER afterChildMdl position
                afterChildMdl.getPosition() + 1
                : // else set to first position
                0;

            if (curPos < newPos) {
              // adjust for "to be removed before newPos" self offset by 1
              newPos--;
            }

            return this.moveChildToPos(childCid, newPos, options);
          },
          // -- not used
          // moveChildBefore: function (childCid, nextToCid, options) {
          //   var newPos = this.get(nextToCid).getPosition()
          //   return this.moveChildToPos(childCid, newPos, options)
          // },

          /**
           *
           * @param {string} childCId
           * @param {number} newPos
           * @param { {silent?: boolean} } [options={silent:false}]
           */
          moveChildToPos: function (childCId, newPos, options) {
            var _this = this;

            var _childCId = _this.get(childCId.cid || childCId).cid,
              _newPos = +newPos,
              _options = _.merge(
                {
                  silent: false,
                },
                options || {}
              );

            var tmpOrder = _this.getElementsOrder(), // only non-deleted elements
              curPos = tmpOrder.indexOf(_childCId);

            if (curPos === _newPos) {
              return;
            }

            // if childCid is part of the order
            if (curPos !== -1) {
              // remove element from old position
              tmpOrder.splice(curPos, 1);

              // if newPos is beyond (removed) curPos + 1
              // e.g. cP: 1, nP: 3
              // if (_newPos > (curPos + 1)) {
              //   // adjust newPos for removed element
              //   _newPos -= 1
              // }
            }
            // insert at new position
            tmpOrder.splice(_newPos, 0, _childCId);

            // reset positions
            _.forEach(
              _this.getNotDeletedElements(),
              /**
               * @param {Model} child
               */
              function (child) {
                var tmpPos = tmpOrder.indexOf(child.cid);
                child.set("position", tmpPos, { silent: true });
              }
            );

            _this.sort({ silent: _options.silent });
          },

          /**
           * returns the next mdl in the list or null (if this is already the last model)
           * @param {string|Object}   mdlOrId     model object or object id/cid
           * @param {object}          [options]
           * @param {function}        [options.filter] function that takes the possible next model as param, e.g. filterFn(mdl){ return mdl.deleted == false; }
           * @param {boolean}         [options.cyclic=false] continues with the first after the last
           *
           * @returns {Object|null} model object       - next model object or null
           *
           * @see {@link BaseCollection.prev}
           */
          next: function (mdlOrId, options) {
            var _this = this,
              _models = _this.models,
              isNext = false,
              nextMdl = null;

            var _options = _.merge(
              {
                filter: function (mdl) {
                  return true;
                },
                cyclic: false,
              },
              options || {}
            );

            var mdlId = mdlOrId.id || mdlOrId;

            _models.forEach(function (mdl0) {
              if (nextMdl) return;
              if (isNext && _options.filter(mdl0)) {
                nextMdl = mdl0;
                return;
              }
              if (mdl0.id == mdlId) {
                isNext = true;
              }
            });

            if (_options.cyclic && !nextMdl) {
              isNext = true;

              _models.forEach(function (mdl0) {
                if (nextMdl) return;
                if (isNext && _options.filter(mdl0)) {
                  nextMdl = mdl0;
                  return;
                }
                if (mdl0.id == mdlId) {
                  isNext = false;
                }
              });
            }

            return nextMdl;
          },

          /**
           * returns the next mdl in the list or null (if this is already the last model)
           * @param   {Object|string}     mdlOrId     -
           * @returns {Object|null}       mdl or null -
           *
           * @see {@link BaseCollection.next}
           *
           */
          prev: function (mdlOrId) {
            var _this = this,
              _models = _this.models,
              wasPrev = false,
              prevMdl = null;

            var mdlId = mdlOrId.id || mdlOrId;

            _models.forEach(function (mdl0) {
              if (wasPrev) return;
              if (mdl0.id == mdlId) {
                wasPrev = true;
                return;
              }
              prevMdl = mdl0;
            });
            return prevMdl;
          },
          /**
           * returns an array of JSON objects from models
           * @returns {object[]}
           */
          toJSON: function(options){
            const
              _this = this,
              arr = _this.models.map(function(mdl){
                return mdl.toJSON(options)
              })

            return arr
          },

          /**
           * finds model based on attribute and updates it
           * or adds a new model
           * @param {string} attrName attribute to compare
           * @param {object} obj
           * @returns {TModel | TModel[]}
           */
          updateWhere: function(attrName, obj){
            var
              _this = this,
              searchObj = {},
              mdl

            searchObj[attrName] = obj[attrName]
            mdl = _this.findWhere(searchObj)
            if(mdl){
              mdl.set(obj)
              if(_this.comparator && obj[_this.comparator] !== undefined){
                // needs an additional "sort" as only setting the model will not trigger a sort on the collection
                _this.sort({silent: true});
              }

            }else{
              mdl = _this.add(obj)
            }
            return mdl
          },
          /**
           * updates the collection by merging the new set with the
           * current based on the attrName (using .findWhere) and removes
           * afterwards all not-updated models
           * @param {string} attrName
           * @param {TModel[]} setArr
           * @returns {TModel[]}
           */
          setWhere: function(attrName, setArr){
            var
              _this = this,
              searchObj = {},
              newSet = setArr.map(function(setObj){
                searchObj[attrName] = setObj[attrName]

                var mdl = _this.findWhere(searchObj)
                if(!mdl){
                  return setObj
                }else{
                  mdl.set(setObj)
                  return mdl
                }
              })

            return _this.set(newSet)
          }
        }
      );

    return {
      Model: BaseModel,
      Collection: BaseCollection
    }

    // ---



    function isTooDeep(obj, options){
      var _options = options || {},
        depth = _options.__depth || 0,
        /**
         * @type {{stack: [], levelCnt: {[string]: number[]}}}
         */
        antiloopstack = _options.__antiloopstack

      // anti endless loop
      var stackIdx = antiloopstack.stack.indexOf(obj),
        levelCnt = stackIdx !== -1 && antiloopstack.levelCnt[stackIdx]

      if(!levelCnt){
        stackIdx = antiloopstack.stack.length
        antiloopstack.stack.push(obj)
        levelCnt = antiloopstack.levelCnt[stackIdx] = []
      }

      if(levelCnt.length + 1 > _options.maxLoop){
        return true
      }
      levelCnt.push(depth)

    }

    function customClone(obj, options){
      var
        _options = options || {},
        depth = _options.__depth,
        _nextLevelOptions = _.merge({}, _options, {__depth: depth + 1})

      _nextLevelOptions.__antiloopstack = _options.__antiloopstack

      if(!obj || ['number', 'boolean', 'string'].indexOf(typeof obj) !== -1) {
        return obj
      }

      if(typeof obj === 'function') {
        return
      }

      if(typeof obj === 'object' && isTooDeep(obj, _options)){
        return '[LOOP_' + _options.maxLoop +  ']'
      }

      if(typeof obj === 'object' && (depth - 1) > _options.maxDepth){
        return '[MAXDEPTH_' + _options.maxDepth + ']'
      }

      if(!!obj.jquery || obj instanceof Window || obj instanceof Node){ // jquery or dom element
        return obj
      }

      if(typeof obj.toJSON === 'function'){ // backbone models & collections
        return obj.toJSON(_nextLevelOptions)
      }

      if(typeof obj.get === 'function'){ // ractive components
        return obj.get()
      }

      if(Array.isArray(obj)){
        return obj.map(function(obj0){ return customClone(obj0, _nextLevelOptions)})
      }

      if(Object.keys(obj).length) {
        return Object.keys(obj).reduce(function(r, k){
          if(_options.ignorePrivateKeys && k.match(/^__/)) return r
          if(_options.filterKeys.indexOf(k) !== -1) return r

          var val1 = customClone(obj[k], _nextLevelOptions)
          if(val1 !== undefined)
            r[k] = val1

          return r
        }, {})
      }

      return obj
    }

  }
)
;
